import React from 'react';
import { MapPinIcon, SearchIcon, SlidersHorizontalIcon } from 'lucide-react';
import { StatusBar } from '../phone/StatusBar';
import { TabBar } from '../phone/TabBar';
import { appEvents } from '../../data/appEvents';
const chips = ['All', 'Fairs', 'Festivals', 'Food', 'Sport'];
export function DiscoverScreen() {
  const [featured, ...rest] = appEvents;
  return <div className="flex h-full flex-col" data-id="element-313" data-mp="2op54vyutdm7w">
      <StatusBar data-id="element-314" data-mp="2oo3uzxpjb5rr" />
      <div className="px-4 pt-5" data-id="element-315" data-mp="2oolx3ayvoe7l">
        <p className="text-[10px] font-medium text-muted" data-id="element-316" data-mp="2to8b3mmj5yhg">Events near you</p>
        <p className="font-display text-[22px] font-extrabold tracking-tight" data-id="element-317" data-mp="2tmf05v4vws3n">Discover</p>
        <div className="mt-3 flex gap-2" data-id="element-318" data-mp="2yfqcucwdo33h">
          <div className="flex h-9 flex-1 items-center gap-2 rounded-full bg-white px-3 text-[10.5px] text-muted ring-1 ring-line" data-id="element-319" data-mp="33drtkr6bzqbs">
            <SearchIcon className="h-3.5 w-3.5" data-id="element-320" data-mp="38e5vrsl9461w" />
            Search events or cities
          </div>
          <span className="grid h-9 w-9 place-items-center rounded-full bg-forest text-white" data-id="element-321" data-mp="3cfiznx4s9z66">
            <SlidersHorizontalIcon className="h-3.5 w-3.5" data-id="element-322" data-mp="3t8o6mken74ds" />
          </span>
        </div>
        <div className="mt-3 flex gap-1.5" data-id="element-323" data-mp="3o8a8pv6r9ath">
          {chips.map((c, i) => <span key={c} className={`rounded-full px-2.5 py-1 text-[9.5px] font-semibold ${i === 0 ? 'bg-ink text-white' : 'bg-white text-muted ring-1 ring-line'}`} data-id="element-324" data-mp="3j978qp5mtusd" data-mpi={i}>
              {c}
            </span>)}
        </div>
      </div>

      <div className="mt-4 space-y-2.5 px-4" data-id="element-325" data-mp="atdpw3ntw785">
        <div className="leaf-md relative h-36 overflow-hidden" data-id="element-326" data-mp="avqf91vx1jv8">
          <img src={featured.image} alt="" className="h-full w-full object-cover" data-id="element-327" data-mp="61vq3ixjkcor" />
          <div className="absolute inset-0 bg-forest-deep/45" data-id="element-328" data-mp="14m1u6lw272i" />
          <span className="absolute right-3 top-3 rounded-full bg-mint px-2 py-0.5 text-[9px] font-bold text-forest-deep" data-id="element-329" data-mp="11zrjz7m5dgl">
            {featured.action} live
          </span>
          <div className="absolute bottom-3 left-4 text-white" data-id="element-330" data-mp="tr6tl86a0l6l">
            <p className="text-[9.5px] font-medium text-white/75" data-id="element-331" data-mp="2o1en65aygz5y">{featured.category}</p>
            <p className="font-display text-[15px] font-bold leading-tight" data-id="element-332" data-mp="2szpx0g1939o6">{featured.title}</p>
            <p className="mt-0.5 flex items-center gap-1 text-[9.5px] text-white/75" data-id="element-333" data-mp="2eb26io69hq53">
              <MapPinIcon className="h-2.5 w-2.5" data-id="element-334" data-mp="2j9dh514ds4od" />
              {featured.city} · {featured.date}
            </p>
          </div>
        </div>
        {rest.map(e => <div key={e.id} className="flex items-center gap-3 rounded-2xl bg-white p-2 ring-1 ring-line" data-id="element-335" data-mp="25byid5s8mkjq">
            <img src={e.image} alt="" className="leaf-sm h-14 w-14 object-cover" data-id="element-336" data-mp="2994g99zg1v2n" />
            <div className="min-w-0 flex-1" data-id="element-337" data-mp="1vdivxg45nzgk">
              <p className="text-[9px] text-muted" data-id="element-338" data-mp="20a98vuknyexr">
                {e.date} · {e.city}
              </p>
              <p className="truncate text-[11.5px] font-bold" data-id="element-339" data-mp="3ppfo5baf99co">{e.title}</p>
              <span className="mt-1 inline-block rounded-full bg-mint-soft px-2 py-0.5 text-[8.5px] font-bold text-forest" data-id="element-340" data-mp="3uosdq3soguiy">
                {e.action}
              </span>
            </div>
          </div>)}
      </div>
      <TabBar active="discover" data-id="element-341" data-mp="1e3560iqbs7uk" />
    </div>;
}